<script>
import DatePicker from "vue2-datepicker";

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {getAliasList, getOperateList, getOperateLog, CreateOperate} from "../../../../api/user";
import Loader from "@/components/widgets/loader";
import Swal from "sweetalert2";

/**
 * Orders component
 */
export default {
    page: {
        title: "操作管理",
        meta: [{
            name: "description",
            content: appConfig.description,
        } ]
    },
    components: {
        DatePicker,
        Layout,
        PageHeader,
    },
    props: {
        updating: {
            type: Boolean,
        },
    },
    data() {
        return {
            logs: [],
            lastId: "",
            timer: null,
            pwd: "",
            current_data: {},
            strategy_setting_dict: {},
            alias_list: [],
            strategy_name_list: [],
            strategyData: [],
            title: "操作管理",
            items: [{
                    text: "",
                    href: "",
                },
                {
                    text: "",
                    active: true,
                },
            ],
            showSetting: false,
            showModal: false,
            showStopModal: false,
            showCreateModal: false,
            isauthenticated: true,
            count: 0,

            aliasValue: "",
            strategyValue: "",
            settingValue: {},
            statusValue: "",
            typeValue: null,
            datepickervalue: "",
        };
    },
    computed: {
        /**
         * Total no. of records
         */
        // rows() {
        //     return this.ordersData.length;
        // },
    },
    mounted() {
        // Set the initial number of items
        this.get_strategy_class()
        this.get_alias_list()
        this.startPolling()
    },
    beforeDestroy() {
        // 停止轮询
        this.stopPolling();
    },
    methods: {
        /**
         * Search the table data with search input
         */
        // onFiltered(filteredItems) {
        //     // Trigger pagination to update the number of buttons/pages due to filtering
        //     this.totalRows = filteredItems.length;
        //     this.currentPage = 1;
        // },
        async fetchLogs() {
            let promise = getOperateLog(this.lastId); return promise.then(res => {
            const data = res
            if (data.length > 0) {
                // 更新lastId为最新的日志ID
                this.lastId = data[0].id;

                // 检查并添加新的日志
                for (let log of data.reverse()) {
                    if (!this.logs.some(l => l.id === log.id)) {
                    this.logs.unshift(log); // 在数组前端添加新的日志
                    }
                }
                }
        }).catch(error => {
            console.log(error)
        })
            },



        startPolling() {
            this.timer = setInterval(this.fetchLogs, 5000); // 5秒轮询一次
        },
        stopPolling() {
            clearInterval(this.timer);
        },
        checkCurrentSetting(current_data) {
            this.current_data = current_data
            this.showSetting = true
        },
        checkCreateSetting() {
            this.showModal = true
        },
        showCreate() {
            this.showCreateModal = true
        },
        showStopSetting(current_data) {
            this.current_data = current_data
            this.showStopModal = true
        },
        closeSetting() {
            this.showSetting = false
            this.settingValue = {}
        },
        get_alias_list() {
        let promise = getAliasList(); return promise.then(res => {
            this.alias_list = res
            console.log(this.alias_list)
        }).catch(error => {
            console.log(error)
        })
        },
        get_strategy_class() {
        let promise = getOperateList(); return promise.then(res => {
            this.strategy_setting_dict = res
            this.strategy_name_list = Object.keys(res)
        }).catch(error => {
            console.log(error)
        })
        },
        chooseAlias(){
            this.strategyValue = ""
            this.settingValue = {}
        },
        chooseStrategy(){
            this.settingValue = Object.assign({}, this.strategy_setting_dict[this.strategyValue]);
            console.log(this.strategy_setting_dict)
        },
        create_Stratagy(pwd){
            let set = this.settingValue
            set["alias"] = this.aliasValue
            set["class_name"] = this.strategyValue
            let data = {
                "setting": set,
                "passwd": pwd
            }
            let promise = CreateOperate(data); return promise.then(res => {
                if (res["code"] == 200){
                    this.pwd = ""
                    Swal.fire({
                    title: "请求成功！",
                    text: res["message"],
                    icon: "success",
                    // background: "#009933"
                    })
                    this.aliasValue = ""
                    this.strategyValue = ""
                    this.settingValue = {}
                    this.showCreateModal = false
                    set = {}
                } else{
                    Swal.fire({
                    title: "请求失败！",
                    text: res["message"],
                    icon: "error",
                    // background: "#cc6633"
                    })
                    this.showCreateModal = false
                    }
                
            }).catch(error => {
                console.log(error)
            })
        }

    },
};
</script>

<template lang="en">
<Layout>
    <PageHeader :title="title"/>

    <form>
        <div class="row">
            <div class="col-xl col-sm-6">
                <div class="form-group mt-3 mb-0">
                    <label>Alias :</label>
                    <b-form-select v-model="aliasValue" :options="alias_list" @change="chooseAlias"></b-form-select>
                </div>
            </div>

            <div class="col-xl col-sm-6">
                <div class="form-group mt-3 mb-0">
                    <label>Strategy</label>
                    <b-form-select v-model="strategyValue" :options="strategy_name_list" @change="chooseStrategy"></b-form-select>
                </div>
            </div>

            <div class="col-xl col-sm-6">
                <div class="form-group mt-3 mb-0">
                    <label>setting</label>
                    <td>
                            <!-- Button trigger modal -->
                            <button
                              type="button"
                              class="btn btn-success btn-sm btn-rounded"
                              @click="checkCreateSetting"
                            >
                              查看配置
                            </button>

                            <b-modal
                              v-model="showModal"
                              title="策略参数配置"
                              centered
                            >
                              <div>
                                <table class="table table-centered table-nowrap">
                                  <!-- <b-form-group
                                    id="example text"
                                    label-cols-lg="5"
                                    label="品种"
                                    label-for="text"
                                  >
                                  <b-form-input v-model="current_strat_symbol" />
                                  </b-form-group> -->
                                  <div v-for="(value,key,index) in settingValue" :key="index">
                                    <b-form-group
                                      id="example text"
                                      label-cols-lg="5"
                                      :label="key"
                                      label-for="text"
                                    >
                                    <b-form-input v-model="settingValue[key]"/>
                                    </b-form-group>
                                  </div>
                                  <!-- <b-form-group
                                    id="example text"
                                    label-cols-lg="5"
                                    label="密码"
                                    label-for="text"
                                  >
                                  <b-form-input type="password" v-model='pwd'/>
                                  </b-form-group> -->
                                </table>
                              </div>
                              <template v-slot:modal-footer>
                                <!-- <b-button
                                  variant="secondary"
                                  @click="runStrategy(current_strat, pwd, current_strat_symbol, current_strat_seting, current_strat_index)"
                                >
                                  确认
                                </b-button> -->
                              </template>
                            </b-modal>
                          </td>
                </div>
            </div>

            <!-- <div class="col-xl col-sm-6">
                <div class="form-group mt-3 mb-0">
                    <label>Status</label>
                    <b-form-select v-model="statusValue" :options="['Completed', 'Pending']"></b-form-select>
                </div>
            </div> -->

            <div class="col-xl col-sm-6 align-self-end">
                <div class="mt-3">
                    <button type="button" 
                    class="btn btn-primary w-md"
                    @click="showCreate()">
                        启动
                    </button>
                    <b-modal
                    v-model="showCreateModal"
                    title="请输入密码"
                    centered
                    >
                    <div>
                        <table class="table table-centered table-nowrap">
                        <b-form-group
                            id="example text"
                            label-cols-lg="4"
                            label="密码"
                            label-for="text"
                        >
                        <b-form-input type="text" v-model='pwd'/>
                        </b-form-group>
                        </table>
                    </div>
                    <template v-slot:modal-footer>
                        <div class="text-center">
                        <b-button
                        variant="secondary"
                        @click="create_Stratagy(pwd)"
                        >
                        确认
                        </b-button>
                    </div>
                    </template>
                    </b-modal>
                </div>
            </div>
        </div>


        <div>
            <h4>操作日志</h4>
            <ul>
            <transition-group name="log" tag="li">
                <li v-for="log in logs" :key="log.id">
                <span class="log-time">{{ log.create_time }}</span>
                <span class="log-name">{{ log.operate_name }}</span>
                <span class="log-msg">{{ log.msg }}</span>
                </li>
            </transition-group>
            </ul>
        </div>

    </form>

    

</Layout>
</template>


<style scoped>
/* 样式 */


ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin-bottom: 10px;
  border: 1px solid #ccc;
  padding: 10px;
}
.no-margin {
  margin: 0;
  padding: 0;
}
.log-time,
.log-name,
.log-msg {
  margin-right: 10px;
}

/* 过渡动画 */
.log-enter-active, .log-leave-active {
  transition: opacity 0.5s;
}
.log-enter, .log-leave-to {
  opacity: 0;
}
</style>
